module.exports = __webpack_public_path__ + "img/arrow-down.8441c047.svg";